import { createTheme } from '@mui/material';

/*
  We can customize MUI theme down below
  More info: https://mui.com/customization/theming/
*/
export const defaultTheme = createTheme({});
